export default __webpack_public_path__ + "static/project-societygal-0353ad61c13a2bc6b24f4c8a8da5d428.png";